import React, { memo, MouseEventHandler } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { Link } from "./styles";

interface LinkCellRendererProps extends ICellRendererParams {
  href?: string;
  target?: string;
  onClick?(data: unknown): (MouseEventHandler<HTMLAnchorElement> & MouseEventHandler<HTMLSpanElement>) | undefined;
  download?: boolean;
}

export const LinkCellRenderer: React.FC<LinkCellRendererProps> = memo(({ onClick, href, value, data, download, target }: LinkCellRendererProps) => (
  <Link
    onClick={onClick?.(data)}
    href={href}
    color="primary"
    download={download}
    target={target}
    rel={target === "_blank" ? "noopener noreferrer" : undefined}
  >
    {value}
  </Link>
));

LinkCellRenderer.displayName = "LinkCellRenderer";

interface DownloadLinkCellRendererProps extends LinkCellRendererProps {
  hrefConstructor(params: ICellRendererParams): string;
}

export const DownloadLinkCellRenderer = memo(({ hrefConstructor, ...params }: DownloadLinkCellRendererProps) => {
  const href = hrefConstructor(params);
  return <LinkCellRenderer {...params} href={href} download />;
});

DownloadLinkCellRenderer.displayName = "DownloadLinkRenderer";

export default LinkCellRenderer;
